import React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { DropdownLabelProps } from './DropdownLabel';
import { IconArrowChevronDown } from '../icons/generated';
import { semantic_colors } from '../../foundation';
import { getDropdownArrowIconSize } from './styles';

interface DropdownArrowButtonProps extends DropdownLabelProps {
  colorProps?: string;
}

export const DropdownArrowButton = ({
  expanded,
  disabled,
  colorProps,
  onClick,
  size = 'medium',
}: DropdownArrowButtonProps) => {
  return (
    <ArrowButton onClick={onClick} aria-hidden>
      <IconArrowChevronDown
        size={getDropdownArrowIconSize(size)}
        css={css`
          ${expanded && 'transform: rotate(180deg)'};
          cursor: ${disabled ? 'not-allowed' : 'pointer'};
        `}
        color={disabled ? semantic_colors.content.disabled : colorProps || semantic_colors.content.tertiary}
      />
    </ArrowButton>
  );
};

const ArrowButton = styled.div`
  flex: none;
  display: flex;
  justify-content: center;
  align-items: center;
`;
